export { AnnotationCanvas, ERASER_RADIUS } from "./AnnotationCanvas"
export type { AnnotationCanvasProps } from "./AnnotationCanvas"
export {
    addStroke,
    annotationSteps,
    clearAnnotation,
    commitErase,
    createAnnotationStore,
    eraseAt,
    startErase,
    strokeHit,
    undoAnnotation,
} from "./annotationStore"
export type { AnnotationOp, AnnotationPoint, AnnotationStore, AnnotationStroke, EraseGesture } from "./annotationStore"
